module.exports = __webpack_public_path__ + "img/in-person-low.ed5cc2ca.png";